import { Route, Routes } from "react-router-dom";
import CrudEmailCampaign from "./CrudEmailCampaign";
import EmailCampaignsList from "./EmailCampaignsList";

export default function EmailMarketingIndex() {
  return (
    <Routes>
      <Route index element={<EmailCampaignsList />} />
      <Route path="new" element={<CrudEmailCampaign />} />
      <Route path=":id" element={<CrudEmailCampaign />} />
    </Routes>
  );
}
